var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32.000000pt",
    height: "32.000000pt",
    viewBox: "0 0 32.000000 32.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,32.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 298 c-33 -17 -51 -35 -67 -68 -29 -56 -29 -84 -1 -140 25 -48 89 -90 138 -90 49 0 113 42 138 90 28 56 28 84 0 140 -25 48 -89 90 -138 90 -14 0 -46 -10 -70 -22z m80 -146 c-30 -78 -50 -110 -50 -79 0 16 45 139 63 171 25 47 17 -13 -13 -92z m-50 48 c0 -6 -11 -16 -25 -22 -14 -6 -25 -14 -25 -18 0 -4 11 -12 25 -18 26 -12 34 -32 13 -32 -7 0 -26 11 -43 25 l-30 25 30 25 c31 26 55 32 55 15z m135 -15 l30 -25 -30 -25 c-16 -14 -36 -25 -42 -25 -22 0 -14 20 12 32 14 6 25 14 25 18 0 4 -11 12 -25 18 -26 12 -34 32 -12 32 6 0 26 -11 42 -25z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDev);
export default __webpack_public_path__ + "static/media/dev.41bfc5a2b6750ce70a19fa9044662e8c.svg";
export { ForwardRef as ReactComponent };